import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
export function ComparisonSection() {
  return <section id="comparison" className="py-12 md:py-20 bg-stone-50" data-id="element-1">
      <div className="max-w-6xl mx-auto px-4 md:px-6" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-10 md:mb-16" data-id="element-3">
          <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-stone-900 mb-4" data-id="element-4">
            O mesmo produto, preços{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-emerald-600" data-id="element-5">
              diferentes
            </span>
          </h2>
          <p className="text-sm md:text-base text-stone-600 max-w-3xl mx-auto" data-id="element-6">
            O que muda não é o material — é a forma de apresentar.
          </p>
        </motion.div>

        {/* Before/After Comparison */}
        <div className="grid grid-cols-2 gap-3 md:gap-8 max-w-5xl mx-auto" data-id="element-7">
          {/* ANTES - Before */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="bg-white rounded-xl md:rounded-3xl shadow-xl overflow-hidden border-2 md:border-4 border-stone-200" data-id="element-8">
            <div className="relative" data-id="element-9">
              <div className="absolute inset-x-0 top-2 md:top-4 flex justify-center z-10" data-id="element-10">
                <div className="bg-stone-500 text-white px-3 py-1.5 md:px-5 md:py-2.5 rounded-full flex items-center gap-1 md:gap-2 shadow-lg" data-id="element-11">
                  <span className="font-bold text-xs md:text-sm" data-id="element-12">COMUM</span>
                </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/bppScnhU7qGGLbchBUJrmZ/IMG_0361.jpg" alt="Lembrancinha comum" className="w-full h-40 md:h-72 object-cover grayscale-[0.3]" data-id="element-13" />
            </div>
            <div className="p-3 md:p-6 bg-stone-50" data-id="element-14">
              <p className="text-stone-700 font-medium text-sm md:text-base" data-id="element-15">
                Aparência Simples
              </p>
              <p className="text-stone-500 text-xs md:text-sm mt-0.5 md:mt-1" data-id="element-16">
                Difícil de valorizar
              </p>
            </div>
          </motion.div>

          {/* DEPOIS - After */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} className="bg-white rounded-xl md:rounded-3xl shadow-xl overflow-hidden border-2 md:border-4 border-amber-400" data-id="element-17">
            <div className="relative" data-id="element-18">
              <div className="absolute inset-x-0 top-2 md:top-4 flex justify-center z-10" data-id="element-19">
                <div className="bg-gradient-to-r from-amber-500 to-yellow-600 text-white px-3 py-1.5 md:px-5 md:py-2.5 rounded-full flex items-center gap-1 md:gap-2 shadow-lg" data-id="element-20">
                  <Check className="w-3 h-3 md:w-5 md:h-5" data-id="element-21" />
                  <span className="font-bold text-xs md:text-sm" data-id="element-22">BOUTIQUE</span>
                </div>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/6Vts8euPDFnwXhFqMDdUsF/IMG_0238.jpg" alt="Lembrancinha com Efeito Boutique" className="w-full h-40 md:h-72 object-cover" data-id="element-23" />
            </div>
            <div className="p-3 md:p-6 bg-gradient-to-br from-amber-50 to-yellow-50" data-id="element-24">
              <p className="text-stone-900 font-medium text-sm md:text-base whitespace-nowrap" data-id="element-25">
                Com Efeito Boutique™
              </p>
              <p className="text-stone-700 text-xs md:text-sm mt-0.5 md:mt-1" data-id="element-26">
                Margem de lucro maior
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}